import React, { useState, useEffect } from "react";
import { colors } from "../../../../themes/Colors";
import { BaseButtons } from "../../../common-components";
import AWS from "aws-sdk";

const BuzzCard = ({
  senderTitle,
  buzzTitle,
  quickDescription,
  longDescription,
  selectedItem,
  index,
  postType,
  sourceLink,
  tagsData,
  onPinnedClick,
  onCommentClick,
  option2,
  subPostType,
  postId,
}) => {
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [imageLink, setImageLink] = useState("");

  const IconDisplay = () => {
    if (postType === "BOLO") {
      return require("./buzzIcons/boloIcon1.png");
    } else if (postType === "VEHICLE") {
      return require("./buzzIcons/vehicleIcon1.png");
    } else if (postType === "WEATHER") {
      return require("./buzzIcons/weatherIcon1.png");
    } else if (postType === "TRAFFIC") {
      return require("./buzzIcons/trafficIcon1.png");
    } else {
      return require("./buzzIcons/generalIcon1.png");
    }
  };

  const getUplaodImage = async () => {
    const S3_BUCKET = process.env.REACT_APP_BUCKET;
    const apiKey = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
    const secrectapiKey = process.env.REACT_APP_AWS_SECRET_KEY_ID;
    AWS.config.update({
      accessKeyId: apiKey,
      secretAccessKey: secrectapiKey,
    });
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: process.env.REACT_APP_REGION,
      signatureVersion: "v4",
    });

    const params = {
      Bucket: S3_BUCKET,
      Key: postId,
    };

    var promise = s3.getSignedUrlPromise("getObject", params);
    // return promise;
    promise.then(
      function (url) {
        if (url) {
          setImageLink(url);
        }
        return url;
      },
      function (err) {
        console.log(err);
      }
    );
  };

  const ColorChange = () => {
    if (postType === "BOLO") {
      return "#9BD0E1";
    } else if (postType === "VEHICLE") {
      return "#EBCCFF";
    } else if (postType === "WEATHER") {
      return "#D26466";
    } else if (postType === "TRAFFIC") {
      return "#FBBB62";
    } else {
      return "#8ED399";
    }
  };

  const ImageDisplay = () => {
    if (subPostType === "ACCIDENT") {
      return require("./buzzIcons/AccidentIcon1.png");
    } else if (subPostType === "STOLEN VEHICLE") {
      return require("./buzzIcons/stolenVehicleIcon1.png");
    } else if (subPostType === "HIJACKING") {
      return require("./buzzIcons/hijackingIcon1.png");
    } else if (subPostType === "MISSING PERSON") {
      return require("./buzzIcons/missingPersonIcon1.png");
    } else if (subPostType === "KIDNAPPING") {
      return require("./buzzIcons/kidnappingIcon1.png");
    } else if (subPostType === "HEAVY RAIN") {
      return require("./buzzIcons/heavyRainIcon1.png");
    } else if (subPostType === "STRONG WINDS") {
      return require("./buzzIcons/strongWindsIcon1.png");
    } else if (subPostType === "SNOW | HAIL") {
      return require("./buzzIcons/snowHailIcon1.png");
    } else if (subPostType === "HIGH | LOW TEMPERATURE") {
      return require("./buzzIcons/tempretureChangeIcon1.png");
    } else if (subPostType === "SLOW TRAFFIC") {
      return require("./buzzIcons/slowMovngIcon1.png");
    } else if (subPostType === "ROAD CLOSURE") {
      return require("./buzzIcons/roadClosureIcon1.png");
    } else if (subPostType === "PROTEST | LOOTING | HEIST") {
      return require("./buzzIcons/ProtestHeistLootingIcon1.png");
    } else if (subPostType === "VEHICLE LAUNCH") {
      return require("./buzzIcons/newVehcileLaunchIcon1.png");
    } else if (subPostType === "SALE") {
      return require("./buzzIcons/VehicleForSaleIcon1.png");
    } else if (subPostType === "RECALL") {
      return require("./buzzIcons/recallUIcon1.png");
    } else if (subPostType === "AFTER MARKET PRODUCTS") {
      return require("./buzzIcons/aftermarketProductsIcon1.png");
    } else if (subPostType === "ANNOUNCEMENTS") {
      return require("./buzzIcons/annoucementIcon1.png");
    } else if (subPostType === "EVENTS") {
      return require("./buzzIcons/eventsIcon1.png");
    } else {
      return require("./genericPlaceimage.jpg");
    }
  };

  useEffect(() => {
    getUplaodImage();
  }, []);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        marginTop: 13,
      }}
    >
      <div
        onClick={detailsOpen ? null : () => setDetailsOpen(true)}
        style={{
          backgroundColor: detailsOpen ? colors.white : colors.white,
          borderRadius: option2
            ? detailsOpen
              ? 10
              : 12
            : detailsOpen
            ? 10
            : 50,
          width: option2 ? "88%" : "90%",
          height: detailsOpen ? 350 : 100,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          transition: "all 0.3s",
          WebkitBoxShadow: "-5px 5px 15px -1px #00000070",
          marginLeft: detailsOpen ? 0 : 20,
        }}
      >
        {/* <div
          style={{
            position: "absolute",
            top: -10,
            right: -5,
            padding: 5,
            backgroundColor: colors.greenDark,
            borderRadius: "100%",
            height: 30,
            width: 30,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {" "}
          <img
            alt="icon"
            src={require("../../../../images/icons/notificationsWhite.png")}
            style={{ height: 30 }}
          />
        </div> */}
        {/* <div
          style={{
            position: "absolute",
            top: -10,
            right: 50,
            padding: 5,
            backgroundColor: colors.greenDark,
            borderRadius: "100%",
            height: 30,
            width: 30,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {" "}
          <img
            alt="icon"
            src={require("../../../../images/icons/notificationsWhite.png")}
            style={{ height: 30 }}
          />
        </div> */}
        <div
          style={{
            display: "flex",
            width: "94%",
            justifyContent: "flex-start",
            alignItems: "center",
            marginTop: 15,
            position: "absolute",
            top: 0,
            zIndex: 9,
            flexDirection: "column",
          }}
        >
          {detailsOpen ? null : (
            <img
              alt="icon"
              src={IconDisplay()}
              style={{
                height: 50,
                padding: 10,
                backgroundColor: colors.white,
                position: "absolute",
                borderRadius: option2 ? 10 : 40,
                left: option2 ? -30 : -15,
                // top: 15,
                WebkitBoxShadow: "-5px 5px 10px -1px #00000070",
              }}
            />
          )}
          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              marginLeft: option2
                ? detailsOpen
                  ? 10
                  : 100
                : detailsOpen
                ? 10
                : 45,
              width: "100%",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: 14,
                display: "flex",
                width: "100%",
                flex: 0.7,
                minHeight: detailsOpen ? 0 : 50,
                maxHeight: detailsOpen ? 20 : 50,
                overflow: "hidden",
                color: detailsOpen ? colors.white : "#000000",
                justifyContent: "flex-start",
                // alignItems: "center",
              }}
            >
              <div
                style={{
                  backgroundColor: detailsOpen ? "#00000030" : null,
                  padding: detailsOpen ? 5 : null,
                  borderRadius: 8,
                }}
              >
                {buzzTitle.toLocaleUpperCase()}
              </div>
            </div>
            <div style={{ height: 10 }}></div>
            <div
              style={{
                fontSize: 12,
                display: "flex",
                width: "100%",
                flex: 0.3,
                color: detailsOpen ? colors.white : "#000000",
              }}
            >
              <div
                style={{
                  width: 150,
                  backgroundColor: detailsOpen ? "#00000030" : null,
                  padding: detailsOpen ? 5 : null,
                  borderRadius: 4,
                }}
              >
                {senderTitle}
              </div>{" "}
              <div style={{ flex: 1 }} />
              <div style={{ width: 100, textAlign: "right" }}>
                {/* {postType.toLocaleUpperCase()} */}
              </div>
            </div>
          </div>
          <div
            style={{
              width: detailsOpen ? "90%" : 0,
              fontSize: 12,
              marginTop: detailsOpen ? 5 : 12,
              display: "flex",
              marginBottom: 5,
              marginLeft: detailsOpen ? -30 : 20,
              overflowX: detailsOpen ? null : "hidden",
              minHeight: 23,
              borderRadius: 8,
              // position:'absolute'
            }}
          >
            {tagsData
              ? tagsData.map((tag, index) => {
                  return (
                    <div
                      style={{
                        marginLeft: 4,
                        fontWeight: "bold",
                        paddingLeft: 5,
                        paddingRight: 5,
                        paddingTop: 5,
                        paddingBottom: 5,
                        borderRadius: 20,
                        backgroundColor: colors.white,
                        fontSize: detailsOpen ? 9 : 11,
                        // WebkitBoxShadow: detailsOpen
                        //   ? "-5px 5px 15px -1px #00000070"
                        //   : null,
                      }}
                      key={index}
                    >
                      #{tag.toLocaleUpperCase()}
                    </div>
                  );
                })
              : null}
          </div>
        </div>

        <div
          style={{
            flex: detailsOpen ? 1 : 0,
            display: "flex",
            width: "94%",
            overflow: "hidden",

            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 8,
              // opacity: 0.5,
              flexDirection: "column",
              overflow: "hidden",
              marginTop: 10,
            }}
          >
            <img
              alt="icon"
              src={imageLink}
              style={{
                height: "100%",
                minHeight: 150,
                // maxHeight: 250,
                // paddingTop: 10,
                borderRadius: 8,
              }}
            />
          </div>
          <div
            style={{
              position: "absolute",
              bottom: 10,
              width: "90%",
              fontSize: 12,
              // left: 10,
              borderRadius: 8,
              backgroundColor: "#FFFFFF50",
              marginTop: 10,
              // marginBottom: 10,
              padding: 10,
            }}
          >
            {longDescription}
          </div>
          <div style={{ position: "absolute", top: 15, right: 5, zIndex: 10 }}>
            <BaseButtons
              label={"X"}
              height={40}
              width={40}
              color={colors.white}
              backgroundColor={colors.orangeDark}
              onClick={() => setDetailsOpen(false)}
              borderRadius={"100%"}
            />
          </div>
        </div>

        {detailsOpen ? <div style={{ height: 10 }} /> : null}
        <div style={{ display: "flex", width: "100%" }}>
          {detailsOpen ? (
            <a
              href={sourceLink}
              target="_blank"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textDecoration: "none",
              }}
            >
              <BaseButtons
                label={"SOURCE"}
                backgroundColor={colors.greenDark}
                borderRadius={8}
                width={"90%"}
                onClick={() => setDetailsOpen(false)}
              />
            </a>
          ) : null}

          {detailsOpen ? (
            <BaseButtons
              label={"COMMENTS"}
              backgroundColor={colors.greenLight}
              borderRadius={8}
              width={"90%"}
              onClick={() => setDetailsOpen(false)}
            />
          ) : null}
          {detailsOpen ? <div style={{ width: 15 }} /> : null}
        </div>

        <div style={{ height: 10 }} />
      </div>
    </div>
  );
};

export default BuzzCard;
